module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.childValue),
      expression: "childValue",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "min-width": "90px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": _vm.placeholder,
      "autosize": {
        minRows: 2,
        maxRows: 10
      },
      "rows": 5,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": (_vm.childValue)
    },
    on: {
      "input": [function($event) {
        _vm.childValue = (typeof $event === 'string' ? $event.trim() : $event)
      }, _vm.change],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4af3f4e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputs/honrayTextarea.vue
// module id = 1852
// module chunks = 2